/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDemoOrganizationRequest } from '../models/CreateDemoOrganizationRequest'
import type { CreateInternalOrganizationRequest } from '../models/CreateInternalOrganizationRequest'
import type { CreateStandardOrganizationRequest } from '../models/CreateStandardOrganizationRequest'
import type { CreateTithelyOrganizationRequest } from '../models/CreateTithelyOrganizationRequest'
import type { OrganizationBasicResource } from '../models/OrganizationBasicResource'
import type { OrganizationFeatureResource } from '../models/OrganizationFeatureResource'
import type { OrganizationFullResource } from '../models/OrganizationFullResource'
import type { OrganizationStatus } from '../models/OrganizationStatus'
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
import type { OrganizationGivingSettingsResource } from '../models/OrganizationGivingSettingsResource'
import type { OrganizationMessagingCountsResource } from '../models/OrganizationMessagingCountsResource'
import type { OrganizationSmsSettingsResource } from '../models/OrganizationSmsSettingsResource'

export class OrganizationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List organizations (with search function).
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizations({
        page,
        search,
        status,
        searchType,
        featureFlags,
        customerId,
        legacyCustomerId,
        tithelyOrganizationId,
        countryId,
        createdFrom,
        createdTo,
        paid,
        tithelyGiving,
        language,
        tithelyAlias,
        internal,
        favorites,
        csv,
        sql,
        columns
    }: {
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
        /**
         * Filter by name, subdomain, OID, user ID, or email address (all users)
         */
        search?: string
        /**
         * Filter by status
         */
        status?: OrganizationStatus
        /**
         * Force how search filters
         */
        searchType?: 'name' | 'subdomain' | 'user_email' | 'primary_email' | 'oid' | 'user_id'
        /**
         * Filter by feature flag state. Keyed by feature name or ID; prefix the key with `hub:` to match a THub feature flag slug or ID instead. Values are 0 (disabled) or 1 (enabled).
         */
        featureFlags?: Record<string, 0 | 1>
        /**
         * Filter by Stripe Customer ID. Supports `*` (has any value) and `!`/`!value` (has no value / has a value other than the given one).
         */
        customerId?: string
        /**
         * Filter by legacy customer ID. Supports `*` (has any value) and `!`/`!value` (has no value / has a value other than the given one).
         */
        legacyCustomerId?: string
        /**
         * Filter by Tithely organization ID. Supports `*` (has any value) and `!`/`!value` (has no value / has a value other than the given one).
         */
        tithelyOrganizationId?: string
        /**
         * Filter by country
         */
        countryId?: number
        /**
         * Filter to organizations created on or after this date
         */
        createdFrom?: string
        /**
         * Filter to organizations created on or before this date
         */
        createdTo?: string
        /**
         * Filter by paid status
         */
        paid?: 0 | 1
        /**
         * Filter by Tithely Giving status. `null` is a distinct, real state (never configured), not "no filter".
         */
        tithelyGiving?: '0' | '1' | 'null'
        /**
         * Filter by organization language
         */
        language?: string
        /**
         * Filter by Tithely alias
         */
        tithelyAlias?: number
        /**
         * Filter to (1) or away from (0) organizations considered internal: staff email domains, demo-like names, or explicitly configured IDs (see support.internalOrganizations app config).
         */
        internal?: 0 | 1
        /**
         * When true, return the current Helm user's favorited organizations instead of the search/recents list, ignoring all other filters.
         */
        favorites?: boolean
        /**
         * When true, respond with a CSV of every matching organization (ignoring pagination) instead of paginated JSON.
         */
        csv?: boolean
        /**
         * When true, respond with the literal SQL query for the current filters as JSON (`{"sql": "..."}`) instead of running it. Requires the `helm.sql_export` permission.
         */
        sql?: boolean
        /**
         * Comma-separated list of columns to include when `csv` is true (id, name, subdomain, status, primary_email, created_on). Defaults to all of them.
         */
        columns?: string
    }): CancelablePromise<{
        data: Array<OrganizationBasicResource>
        meta: paginationMeta & {
            /**
             * Total recent organizations viewed
             */
            totalRecents?: number
        }
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations',
            query: {
                page: page,
                search: search,
                status: status,
                search_type: searchType,
                feature_flags: featureFlags,
                customer_id: customerId,
                legacy_customer_id: legacyCustomerId,
                tithely_organization_id: tithelyOrganizationId,
                country_id: countryId,
                created_from: createdFrom,
                created_to: createdTo,
                paid: paid,
                tithely_giving: tithelyGiving,
                language: language,
                tithely_alias: tithelyAlias,
                internal: internal,
                favorites: favorites,
                csv: csv,
                sql: sql,
                columns: columns
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Used for creating organizations.
     * @returns any Created
     * @throws ApiError
     */
    public createOrganization({
        requestBody
    }: {
        requestBody?:
            | CreateStandardOrganizationRequest
            | CreateDemoOrganizationRequest
            | CreateTithelyOrganizationRequest
            | CreateInternalOrganizationRequest
            | {
                  flow: 'standard' | 'demo' | 'tithely' | 'internal'
                  features?: 'tithely-giving-30'
                  /**
                   * Sets the tithely_giving organization property
                   */
                  tithely_giving?: boolean
              }
    }): CancelablePromise<{
        data: {
            subdomain: string
            organization_id: number
            /**
             * Only for "tithely" flow. Maps Tithely User ID to Breeze User ID
             */
            users?: Record<string, number>
        }
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Show a single organization (returns basic info).
     * @returns any OK
     * @throws ApiError
     */
    public getOrganization({
        id,
        subscription
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        /**
         * Include subscription information from Tithe.ly and Stripe
         */
        subscription?: boolean
    }): CancelablePromise<{
        data: OrganizationFullResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{id}',
            path: {
                id: id
            },
            query: {
                subscription: subscription
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete an Organization (soft delete by default).
     * @returns any Accepted
     * @throws ApiError
     */
    public deleteOrganization({
        id,
        force = false
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        /**
         * Force delete (hard delete). Will return empty response.
         */
        force?: boolean
    }): CancelablePromise<{
        data: OrganizationBasicResource
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/organizations/{id}',
            path: {
                id: id
            },
            query: {
                force: force
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Advanced update endpoint for organizations.
     * Can update details that are not available in the normal update endpoint.
     * @returns any OK
     * @throws ApiError
     */
    public updateOrganization({
        id,
        requestBody
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody: {
            name?: string
            subdomain?: string
            status?: number
            /**
             * Stripe Customer ID
             */
            customer_id?: string
            country_id?: number
            language?: string
            /**
             * Sets the tithely_giving organization property
             */
            tithely_giving?: boolean
        }
    }): CancelablePromise<{
        data: OrganizationBasicResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{id}',
            path: {
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationFeatures({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: Array<OrganizationFeatureResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/features',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationFeature({
        organization,
        id
    }: {
        /**
         * Organization ID
         */
        organization: number
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: OrganizationFeatureResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/features/{id}',
            path: {
                organization: organization,
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Toggle a feature for an organization.
     * This is for organization level only.
     * @returns any OK
     * @throws ApiError
     */
    public updateOrganizationFeature({
        organization,
        id,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody?: {
            enabled: boolean | null
            /**
             * Why the organization-level toggle is being set. Only meaningful when disabling.
             */
            reason?: string | null
        }
    }): CancelablePromise<{
        data: OrganizationFeatureResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{organization}/features/{id}',
            path: {
                organization: organization,
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationGivingSettings({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: OrganizationGivingSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/giving-settings',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
    /**
     * Dispatches a request to enable or disable Stripe transfers for the organization's giving
     * account. Calls the live Stripe API and updates `transfers_enabled` on success.
     * @returns any OK
     * @throws ApiError
     */
    public setOrganizationGivingTransfersEnabled({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: {
            enabled: boolean
        }
    }): CancelablePromise<{
        data: OrganizationGivingSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/giving-settings/dispatch/set-transfers-enabled',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public setOrganizationGivingUnderReview({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: {
            enabled: boolean
            suppress_email?: boolean
        }
    }): CancelablePromise<{
        data: OrganizationGivingSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/giving-settings/dispatch/set-under-review',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
    /**
     * Updates the giving settings that have no external side effects. `transfers_enabled` and
     * `under_review` are read-only here — they're written via the dispatch endpoints on
     * {@see OrganizationGivingSettingsActionController}, which also call the live Stripe API and
     * send notices, so they must not be reachable through this plain settings PATCH.
     * @returns any OK
     * @throws ApiError
     */
    public updateOrganizationGivingSettings({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: {
            strict_ip_enabled?: boolean
            whitelisted?: boolean
            card_fee_percent?: number
            /**
             * US organizations only.
             */
            ach_fee_percent?: number
        }
    }): CancelablePromise<{
        data: OrganizationGivingSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{organization}/giving-settings',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationMessagingCounts({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: OrganizationMessagingCountsResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/messaging-counts',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationSmsSettings({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: OrganizationSmsSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/sms-settings',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateOrganizationSmsSettings({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: {
            whitelisted?: boolean
            fraud_whitelisted?: boolean
        }
    }): CancelablePromise<{
        data: OrganizationSmsSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{organization}/sms-settings',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
